import { ActiveMenu } from "../../StateManagment/ActiveMenuItem";
import { Auth } from '../../StateManagment/Auth';
import { useContext } from "react";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useHistory } from 'react-router-dom';
import { client } from "../../hooks/Client"

const AdressesExplainer = () => {
     // Context
     const [auth] = useContext(Auth)
     const { active, setActive, activeSubItem, setActiveSubItem } = useContext(ActiveMenu);
    
     // Hooks
     const history = useHistory()
    
    const segmentSteps = [
      {
        name: 'Dashboard',
        url: 'housevisitsdashboard'
      },
      {
        name: 'Adressen',
        url: 'housevisitsoverview'
      },
      {
        name: 'Planning',
        url: 'agenda'
      },
      {
        name: 'Instellingen',
        url: 'housevisitssettings'
      }
    ]

  return (
     <div className="main">
      <div className="main-container">
          <div className="page-header">
              <HomeOutlinedIcon/>
              <h1>Huisbezoeken</h1>
          </div>
          <div className='section-explainer-text-container'>
            <div>
              <p>Welkom bij de huisbezoeken, {auth?.ForName}. Hier kun je huisbezoeken plannen en beheren.</p>
            </div>
            <div id='segment-overview-steps-container'>
              {segmentSteps.map((step, index) => (
                <div 
                key={index} 
                className="segment-overview-step-container"
                onClick={() => {
                  history.push(`/${client}/${step.url}`);
                  setActive('personas');
                  setActiveSubItem(step.url)
                }}
                >
                  <div className="segment-overview-step-inner-container">
                    <div className="segment-overview-checked-name-container">
                      <div>
                        <p><b>{step.name}</b></p>
                      </div>
                    </div>
                    <p id='segment-overview-step-button'>Bekijk/aanpassen</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
  )
}

export default AdressesExplainer